module.exports = __webpack_public_path__ + "static/img/12.18e2d61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/12.png
// module id = QrXw
// module chunks = 35